import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FiltrosOrdenAdmisionEntity, DataOrdenSuministroAdmisionEntity, ServicioOrdenAdmisionService } from '../../../../../services/servicio-orden-admision.service';
import { EntidadEmpresarialEntity, ServicioEntidadService } from '../../../../../services/servicio-entidad.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-header-orden-suministro-admision',
  templateUrl: './header-orden-suministro-admision.component.html',
  styleUrls: ['./header-orden-suministro-admision.component.css']
})
export class HeaderOrdenSuministroAdmisionComponent implements OnInit {

  loading: boolean;
  mensajeError: string;

  @Input() public filtros: FiltrosOrdenAdmisionEntity;

  @Output() emitLoading: EventEmitter<boolean>;
  @Output() emitError: EventEmitter<string>;
  @Output() emitData: EventEmitter<{ entidad: EntidadEmpresarialEntity, data: DataOrdenSuministroAdmisionEntity[]}>;

  entidad: EntidadEmpresarialEntity;
  data: DataOrdenSuministroAdmisionEntity[];

  constructor(private servicioOrdenAdmision: ServicioOrdenAdmisionService,
    private servicioEntidad: ServicioEntidadService) {
      this.emitLoading = new EventEmitter();
      this.emitError = new EventEmitter();
      this.emitData = new EventEmitter();
  }

  ngOnInit() {
    this.getEntidadEmpresarial();
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.filtros.codigoBaseDatos, this.filtros.uncoSede);
      if (response != null) {
        response.subscribe((data: any) => {
          this.entidad = data[0];
          this.getOrdenAdmision();
        }, (err: HttpErrorResponse) => {
          this.entidad = null;
          this.data = null;
          console.error('Error getEntidadEmpresarial()', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información de la entidad, reporte caso al administrador');
        });
      }
    } catch (e) {
      this.entidad = null;
      this.data = null;
      console.error('Error Catch getEntidadEmpresarial()', e);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información de la entidad, reporte caso al administrador');
    }
  }

  async getOrdenAdmision() {
    try {
      const response = await this.servicioOrdenAdmision.getOrdenSuministroAdmision(this.filtros.codigoBaseDatos, this.filtros.consecutivo);
      if (response != null) {
        response.subscribe((data: DataOrdenSuministroAdmisionEntity[]) => {
          this.data = data;
          this.emitData.emit({entidad : this.entidad, data: data});
          this.setLoading(false);
        }, (err: HttpErrorResponse) => {
          this.data = [];
          console.error('Error getData()', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos de la orden admisión, reporte caso al administrador');
          this.setLoading(false);
        });
      }
    } catch (e) {
      this.data = [];
      console.error('Error getData()', e);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos de la orden admisión, reporte caso al administrador');
      this.setLoading(false);
    }
  }

  // Listener
  onGenerar() {
    this.setLoading(true);
    this.getOrdenAdmision();
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('orden-admision-suministro').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

  // Auxiliar
  setLoading(value: boolean) {
    this.loading = value;
    this.emitLoading.emit(value);
  }

  showMessage(error: string, life?: number) {
    this.mensajeError = error;
    const timeout = life ? life : 3500;
    setTimeout(() => {
      this.mensajeError = null;
    }, timeout);
  }

  isDisabledImprimir() {
    return this.loading || !this.data || this.data === null || this.data.length === 0;
  }

}
